import React from "react";

const CloseOutlined = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7781 18.9897L14.7757 13.9873L19.7781 8.98487C20.0055 8.75743 20.1333 8.44896 20.1333 8.12732C20.1333 7.80567 20.0055 7.4972 19.7781 7.26976C19.5506 7.04232 19.2422 6.91455 18.9205 6.91455C18.5989 6.91455 18.2904 7.04232 18.063 7.26976L13.0605 12.2722L8.05814 7.26976C7.8307 7.04232 7.52223 6.91455 7.20059 6.91455C6.87894 6.91455 6.57047 7.04232 6.34303 7.26976C6.11559 7.4972 5.98782 7.80567 5.98782 8.12732C5.98782 8.44896 6.11559 8.75743 6.34303 8.98487L11.3454 13.9873L6.34303 18.9897C6.11559 19.2171 5.98782 19.5256 5.98782 19.8472C5.98782 20.1689 6.11559 20.4774 6.34303 20.7048C6.57047 20.9322 6.87894 21.06 7.20059 21.06C7.52223 21.06 7.8307 20.9322 8.05814 20.7048L13.0605 15.7024L18.063 20.7048C18.2904 20.9322 18.5989 21.06 18.9205 21.06C19.2422 21.06 19.5506 20.9322 19.7781 20.7048C20.0055 20.4774 20.1333 20.1689 20.1333 19.8472C20.1333 19.5256 20.0055 19.2171 19.7781 18.9897Z"
        fill="black"
      />
    </svg>
  );
};

export default CloseOutlined;
